module.exports = __webpack_public_path__ + "img/Ornamen_Bulat_04.dec77b31.png";